export default __webpack_public_path__ + "static/media/shrutiE.4c7b8e2b.wav";